<template>
  <v-row>
    <v-col>
      <v-table class="mt-1 table-striped">
        <tbody class="font-size-10-rem">
          <tr>
            <td class="text-left w-75">
              十分理解できた
            </td>
            <td class="text-left">
              {{ understanding.understanding4.value }}({{ understanding.understanding4.percent }}%)
            </td>
          </tr>
          <tr>
            <td class="text-left w-75">
              まあまあ理解できた
            </td>
            <td class="text-left">
              {{ understanding.understanding3.value }}({{ understanding.understanding3.percent }}%)
            </td>
          </tr>
          <tr>
            <td class="text-left w-75">
              あまり理解できなかった
            </td>
            <td class="text-left">
              {{ understanding.understanding2.value }}({{ understanding.understanding2.percent }}%)
            </td>
          </tr>
          <tr>
            <td class="text-left">
              全く理解できなかった
            </td>
            <td class="text-left w-75">
              {{ understanding.understanding1.value }}({{ understanding.understanding1.percent }}%)
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"
import { Understanding } from "../../stores/store_types"

export default defineComponent({
  name: "UnderstandingAnalyticsPart",
  props: {
    understandingProp: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const understanding = computed(() => props.understandingProp as Understanding)

    return {
      understanding
    }
  }
})
</script>
